/**
 * @generated SignedSource<<72ea18c30d678aee1de79db3a4cacdda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HotelSearchSelectRefetchQuery$variables = {
  search?: string | null;
  searching?: boolean | null;
};
export type HotelSearchSelectRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HotelSearchSelect_data">;
};
export type HotelSearchSelectRefetchQuery = {
  response: HotelSearchSelectRefetchQuery$data;
  variables: HotelSearchSelectRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "searching"
  }
],
v1 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HotelSearchSelectRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "searching",
            "variableName": "searching"
          }
        ],
        "kind": "FragmentSpread",
        "name": "HotelSearchSelect_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HotelSearchSelectRefetchQuery",
    "selections": [
      {
        "condition": "searching",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              (v1/*: any*/)
            ],
            "concreteType": "HotelSearchResult",
            "kind": "LinkedField",
            "name": "hotelSearch",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "internalId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3b3388d2e48b038ce264d2192da8cc5b",
    "id": null,
    "metadata": {},
    "name": "HotelSearchSelectRefetchQuery",
    "operationKind": "query",
    "text": "query HotelSearchSelectRefetchQuery(\n  $search: String\n  $searching: Boolean = false\n) {\n  ...HotelSearchSelect_data_2s1XYW\n}\n\nfragment HotelSearchSelect_data_2s1XYW on Query {\n  hotelSearch(search: $search) @include(if: $searching) {\n    name\n    internalId\n    externalId\n  }\n}\n"
  }
};
})();

(node as any).hash = "99397e1a1d4e75208a234a55d4844245";

export default node;
